
//comment
import { useEffect } from "react"

const { Box, TextField, Button, Typography, CircularProgress } = require("@mui/material")
const { useState } = require("react")

/**
 * @typedef TreeDocsDetailsSearchProps
 * @property {string} defaultValue - initial search text
 * @property {function} findTreeDocs - called with invoiceNumber after user enters text and presses search button
 * @property {boolean} pageLoading - are we loading invoice data from the server?
 * @property {object} sx - mui styles
 */

/**
 * 
 * @param {TreeDocsDetailsSearchProps} props 
 * @returns JSX
 */
export default function VegSearchDocsByNumber({defaultValue, findTreeDocs, pageLoading, sx}) {
    const [trprNumber, setTrprNumber] = useState(defaultValue || '') // Tree doc number typed by user into search field.
    const [trprNumberError, setTrprNumberError] = useState()
    const [trprNumberHelperText, setTrprNumberHelperText] = useState('')

    useEffect(() => {
        console.log('VegSearchDocsByNumber useEffect defaultValue', defaultValue)
        if (defaultValue) {
            setTrprNumber(defaultValue)
        }
    }, [defaultValue])

    useEffect(() => {
        const trprNumberOK = isTrprNumber(trprNumber)
        setTrprNumberError(!trprNumberOK)
        setTrprNumberHelperText(trprNumberOK ? '' : 'TRPR then at least three digits please, e.g. TRPR14967, or TRPR10404')
    }, [trprNumber])

    const handleTrprNumberChange = (e) => {
        const theTrprValue = e.target.value ? e.target.value.toUpperCase() : ''
        console.log('VegSearchDocsByNumber handleTrprNumberChange e.target.value', theTrprValue)
        setTrprNumber(theTrprValue)
    }

    const isTrprNumber = (theTrprNumber) => {
        return theTrprNumber?.match(/^TRPR\d\d\d+/i)
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        findTreeDocs(trprNumber)
    }

    console.log('VegSearchDocsByNumber RENDER')

    return (
        <Box sx={sx}>
            <form onSubmit={handleSubmit }>
                <Typography variant="body1" sx={{mb: 2}}>Search Tree Documents by TRPR number.</Typography>
                <Box sx={{mb: 2}}>
                    <TextField
                        label="TRPR Number"
                        placeholder="E.g. TRPR14967"
                        value={trprNumber}
                        onChange={handleTrprNumberChange}
                        error={trprNumberError}
                        helperText={trprNumberHelperText}
                    />
                </Box>
                <Box>
                    <Button type="submit" disabled={trprNumberError || pageLoading} sx={{mr:2}} variant="contained">Find Tree Agreement</Button>
                    { pageLoading && <CircularProgress color="secondary" size="1.0em" /> }
                </Box>
            </form>
        </Box>
    )
}
